import type {OffersCalculateRequest} from '../../../repo/dcaa/types'
import type {GetOffersPayload} from '../types'

export function toOffersCalculateRequest(payload: GetOffersPayload): OffersCalculateRequest {
  const {routePoints, deliveryInterval, items, paymentInfo, tariffRequirements, preOrderId, due} = payload

  const request: OffersCalculateRequest = {
    payment_info: {
      kind: paymentInfo.method,
      method_id: paymentInfo.methodId,
      has_disable_reason: paymentInfo.isDisabled,
      type: paymentInfo.type,
    },
    items: items.map(item => ({
      pickup_point: item.sourcePointId,
      dropoff_point: item.destinationPointId,
      quantity: item.quantity,
      title: item.title,
      cost_currency: item.currency,
      cost_value: item.cost || '0',
    })),
    route_points: routePoints,
    requirements: tariffRequirements,
    due,
  }

  if (deliveryInterval) {
    request.cargo_options = {
      delivery_interval: deliveryInterval,
    }
  }

  if (preOrderId) {
    request.pre_order_id = preOrderId
  }

  return request
}
